export const DOCUMENT_CATEGORY_NAMES: Record<string, string> = {
  'airworthiness': 'Airworthiness Certificate',
  'registration': 'Aircraft Registration Certificate',
  'insurance': 'Insurance Documentation',
  'maintenance': 'Maintenance Records',
  'inspection': 'Inspection Reports',
  'weight_balance': 'Weight & Balance Report',
  'flight_manual': 'Flight Manual',
  'lease_agreement': 'Lease Agreement',
  'pilot_qualifications': 'Pilot Qualifications',
  'operating_manual': 'Operating Manual',
  'remaining_components': 'Component Time Records',
  'component_compliance': 'Component Compliance',
  'avionics_docs': 'Avionics Documentation',
  'propulsion_records': 'Engine/Propulsion Records',
  'structural_inspection': 'Structural Inspection Reports',
  'emergency_equipment': 'Emergency Equipment Certification',
  'modification_records': 'Modification Records (STC/337)',
  'other': 'Additional Documentation'
};

export const getDocumentCategoryName = (category: string): string => {
  return DOCUMENT_CATEGORY_NAMES[category] || category.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};